// Buy now btn

function addTocartScript(){
  setTimeout(() => {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        
        var raw = JSON.stringify({
          "quantity": 1
        });
        
        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: raw,
          redirect: 'follow'
        };
        
        fetch("/cart/add.js", requestOptions)
          .then(response => response.text())
          .then(result => console.log(result))
          .catch(error => console.log('error', error));   
      }, 1000);
 }

// Price remove zero
function updatePrice(){
var prices = document.querySelectorAll(`.price-item`);


if (!prices)return;

for (var each of prices){
each.innerText = each.innerText.replace('.00', '');
}
}

 window.onload = function() {
setTimeout(updatePrice, 50);
}



// Select all buttons with the class .slider-button
let buttons = document.querySelectorAll(".slider-button");

function removeDisabledAttribute() {
    setTimeout(() => {
        buttons.forEach(button => {
            button.removeAttribute("disabled");
          button.addEventListener('click', function (e) {
            setTimeout(() => {
              console.log("remove attribute")
                button.removeAttribute("disabled");
               }, 1000); 
        });
        });
    }, 3000); // Wait for 3 seconds
}

document.addEventListener('DOMContentLoaded', () => {
    removeDisabledAttribute();
});










function changeSlide(direction) {
  var items = document.querySelectorAll('.product__media-item');
  var activeIndex = -1;

  // Find the index of the currently active item
  for (var i = 0; i < items.length; i++) {
    if (items[i].classList.contains('is-active')) {
      activeIndex = i;
      break;
    }
  }

  // If no active item found, return
  if (activeIndex === -1) return;

  // Remove 'is-active' class from all items
  items.forEach(function(item) {
    item.classList.remove('is-active');
  });

  // Determine the index of the next or previous item
  var newIndex;
  if (direction === 'prev') {
    newIndex = (activeIndex === 0) ? activeIndex : activeIndex - 1;
    
  } else if (direction === 'next') {
    newIndex = (activeIndex === items.length - 1) ? activeIndex : activeIndex + 1;
  }

  // Add 'is-active' class to the new active item
  items[newIndex].classList.add('is-active');
}




// Bubble on mouse move


document.addEventListener("mousemove", (event) => {
  const soap = document.querySelector(".soap");
  soap.style.left = event.pageX + "px";
  soap.style.top = event.pageY + "px";

  if (!document.bubbleThrottle) {
    createBubble(event.pageX, event.pageY);
    document.bubbleThrottle = true;
    setTimeout(() => document.bubbleThrottle = false, 100); // adjust delay as needed
  }
});

function createBubble(x, y) {
  const bubble = document.createElement("i");
  bubble.style.left = x + "px";
  bubble.style.top = y + "px";
  bubble.style.transform = `scale(${Math.random() * 1 + 1})`;
  bubble.style.setProperty("--x", getRandomPosition());
  bubble.style.setProperty("--y", getRandomPosition());

  function getRandomPosition() {
    return `${Math.random() * 200 - 100}px`;
  }

  document.querySelector('.bubbles').appendChild(bubble);

  setTimeout(() => {
    bubble.remove();
  }, 2000);
}


// header menu open on hover

 let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  console.log(items)
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
  
  });



